export const SubscriptIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.2 13.7C11.2 13.3005 11.255 12.9539 11.3652 12.66C11.48 12.3616 11.666 12.0907 11.9231 11.8473C12.1802 11.604 12.5337 11.3652 12.9837 11.1311C13.2224 11.0025 13.4038 10.8946 13.5278 10.8074C13.6563 10.7156 13.7482 10.6214 13.8033 10.525C13.8629 10.4286 13.8928 10.3115 13.8928 10.1738C13.8928 9.96258 13.8239 9.79499 13.6862 9.67103C13.5484 9.54247 13.3533 9.47819 13.1008 9.47819C12.8253 9.47819 12.6049 9.55624 12.4396 9.71235C12.2743 9.86845 12.1733 10.0957 12.1366 10.3942L11.2137 10.3391C11.2596 9.82484 11.4456 9.42309 11.7716 9.13384C12.1022 8.84458 12.5452 8.69995 13.1008 8.69995C13.4543 8.69995 13.7596 8.76193 14.0168 8.8859C14.2785 9.00528 14.4759 9.17516 14.609 9.39554C14.7468 9.61593 14.8157 9.87075 14.8157 10.16C14.8157 10.4125 14.772 10.626 14.6848 10.8005C14.6022 10.975 14.469 11.1357 14.2854 11.2826C14.1063 11.4295 13.8469 11.5925 13.5071 11.7716C13.1123 11.9828 12.8115 12.1894 12.6049 12.3914C12.3983 12.5888 12.2881 12.7656 12.2743 12.9217H14.8157V13.7H11.2Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.96967 1.96967C2.26256 1.67678 2.73744 1.67678 3.03033 1.96967L10.5303 9.46967C10.8232 9.76256 10.8232 10.2374 10.5303 10.5303C10.2374 10.8232 9.76256 10.8232 9.46967 10.5303L1.96967 3.03033C1.67678 2.73744 1.67678 2.26256 1.96967 1.96967Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5303 1.96967C10.2374 1.67678 9.76256 1.67678 9.46967 1.96967L1.96967 9.46967C1.67678 9.76256 1.67678 10.2374 1.96967 10.5303C2.26256 10.8232 2.73744 10.8232 3.03033 10.5303L10.5303 3.03033C10.8232 2.73744 10.8232 2.26256 10.5303 1.96967Z"
      fill="currentColor"
    />
  </svg>
)
